import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  memberBenefits: {
    background: theme.palette.grey[100],
  },
}))

export default useStyles
